<template>
	<!-- 导航栏 -->
	<header>
		<div class="container">
			<nav class="navbar">
				<a href="#" class="logo">
					<div class="logo-icon">
						<!-- <i class="fas fa-calculator"></i> -->
						<img src="../assets/logo.png" />
					</div>
					鹏峰财税
				</a>
				<ul class="nav-links">
					<li><router-link to="/">首页</router-link></li>
					<li><router-link to="/products">服务项目</router-link></li>
					<li><router-link to="/aboutUs">关于我们</router-link></li>
					<li><router-link to="/news">新闻资讯</router-link></li>
				</ul>
				<div class="mobile-menu">
					<i class="fas fa-bars"></i>
				</div>
			</nav>
		</div>
	</header>
</template>

<script>
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		font-family: 'Helvetica Neue', Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
	}

	:root {
		--primary: #1a5fad;
		--primary-dark: #0f4a8a;
		--primary-light: #2c80d6;
		--secondary: #ff6b35;
		--accent: #00c4cc;
		--light: #f8f9fa;
		--dark: #343a40;
		--gray: #6c757d;
		--light-gray: #e9ecef;
		--border-radius: 8px;
		--box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
		--transition: all 0.3s ease;
	}

	body {
		color: var(--dark);
		line-height: 1.6;
		background-color: #f5f7fa;
	}

	.container {
		width: 100%;
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 15px;
	}

	/* 导航栏样式 */
	header {
		background-color: white;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1000;
	}

	.navbar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 15px 0;
	}

	.logo {
		display: flex;
		align-items: center;
		font-weight: 700;
		font-size: 24px;
		color: var(--primary);
	}

	.logo-icon {
		width: 40px;
		height: 40px;
		background: var(--primary);
		border-radius: 50%;
		margin-right: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
	}

	.nav-links {
		display: flex;
		list-style: none;
	}

	.nav-links li {
		margin-left: 30px;
	}

	.nav-links a {
		color: var(--dark);
		text-decoration: none;
		font-weight: 500;
		padding: 5px 0;
		position: relative;
		transition: var(--transition);
	}

	.nav-links a:after {
		content: '';
		position: absolute;
		width: 0;
		height: 2px;
		bottom: 0;
		left: 0;
		background-color: var(--primary);
		transition: var(--transition);
	}

	.nav-links a:hover,
	.nav-links a.active {
		color: var(--primary);
	}

	.nav-links a:hover:after,
	.nav-links a.active:after {
		width: 100%;
	}

	.mobile-menu {
		display: none;
		font-size: 24px;
		cursor: pointer;
	}

	/* 英雄区域样式 */
	.hero {
		background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
		color: white;
		padding: 180px 0 100px;
		margin-top: 70px;
		position: relative;
		overflow: hidden;
	}

	.hero:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="%23ffffff" fill-opacity="0.1" d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,192C1248,192,1344,128,1392,96L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>');
		background-size: cover;
		background-position: center;
	}

	.hero-content {
		position: relative;
		z-index: 1;
		max-width: 800px;
	}

	.hero h1 {
		font-size: 48px;
		margin-bottom: 20px;
		line-height: 1.2;
	}

	.hero p {
		font-size: 20px;
		margin-bottom: 30px;
		opacity: 0.9;
	}

	.btn {
		display: inline-block;
		padding: 12px 30px;
		background-color: var(--secondary);
		color: white;
		border-radius: 30px;
		font-weight: 500;
		text-decoration: none;
		transition: var(--transition);
		border: none;
		cursor: pointer;
		box-shadow: 0 4px 15px rgba(255, 107, 53, 0.4);
	}

	.btn:hover {
		background-color: #e55a2b;
		transform: translateY(-3px);
		box-shadow: 0 6px 20px rgba(255, 107, 53, 0.5);
		color: white;
	}

	.btn-outline {
		background-color: transparent;
		border: 2px solid white;
		margin-left: 15px;
	}

	.btn-outline:hover {
		background-color: white;
		color: var(--primary);
	}

	/* 服务区域样式 */
	.section {
		padding: 100px 0;
	}

	.section-title {
		text-align: center;
		margin-bottom: 60px;
	}

	.section-title h2 {
		font-size: 36px;
		color: var(--primary);
		margin-bottom: 15px;
		position: relative;
		display: inline-block;
	}

	.section-title h2:after {
		content: '';
		position: absolute;
		width: 60px;
		height: 4px;
		background-color: var(--secondary);
		bottom: -10px;
		left: 50%;
		transform: translateX(-50%);
	}

	.section-title p {
		color: var(--gray);
		max-width: 700px;
		margin: 20px auto 0;
		font-size: 18px;
	}

	.services-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		gap: 30px;
	}

	.service-card {
		background-color: white;
		border-radius: var(--border-radius);
		padding: 30px;
		box-shadow: var(--box-shadow);
		transition: var(--transition);
		text-align: center;
		border-top: 4px solid var(--primary);
	}

	.service-card:hover {
		transform: translateY(-10px);
		box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
	}

	.service-icon {
		width: 70px;
		height: 70px;
		background-color: var(--light);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 auto 20px;
		color: var(--primary);
		font-size: 28px;
	}

	.service-card h3 {
		font-size: 22px;
		margin-bottom: 15px;
		color: var(--dark);
	}

	.service-card p {
		color: var(--gray);
		margin-bottom: 20px;
	}

	.service-link {
		color: var(--primary);
		text-decoration: none;
		font-weight: 500;
		display: inline-flex;
		align-items: center;
		transition: var(--transition);
	}

	.service-link i {
		margin-left: 5px;
		transition: var(--transition);
	}

	.service-link:hover {
		color: var(--primary-dark);
	}

	.service-link:hover i {
		transform: translateX(5px);
	}

	/* 关于我们样式 */
	.about {
		background-color: var(--light);
	}

	.about-content {
		display: flex;
		align-items: center;
		gap: 50px;
	}

	.about-text {
		flex: 1;
	}

	.about-text h2 {
		font-size: 36px;
		color: var(--primary);
		margin-bottom: 20px;
	}

	.about-text p {
		margin-bottom: 20px;
		color: var(--gray);
	}

	.about-stats {
		display: flex;
		margin-top: 30px;
		gap: 30px;
	}

	.stat {
		text-align: center;
	}

	.stat-number {
		font-size: 36px;
		font-weight: 700;
		color: var(--primary);
		display: block;
	}

	.stat-label {
		color: var(--gray);
		font-size: 14px;
	}

	.about-image {
		flex: 1;
		border-radius: var(--border-radius);
		overflow: hidden;
		box-shadow: var(--box-shadow);
	}

	.about-image img {
		width: 100%;
		height: auto;
		display: block;
		transition: var(--transition);
	}

	.about-image:hover img {
		transform: scale(1.05);
	}

	/* 数据展示样式 */
	.data-section {
		background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
		color: white;
		text-align: center;
		padding: 80px 0;
	}

	.data-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
		gap: 30px;
		margin-top: 50px;
	}

	.data-item {
		padding: 20px;
	}

	.data-number {
		font-size: 48px;
		font-weight: 700;
		margin-bottom: 10px;
		display: block;
	}

	.data-label {
		font-size: 18px;
		opacity: 0.9;
	}

	/* 新闻区域样式 */
	.news-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		gap: 30px;
	}

	.news-card {
		background-color: white;
		border-radius: var(--border-radius);
		overflow: hidden;
		box-shadow: var(--box-shadow);
		transition: var(--transition);
	}

	.news-card:hover {
		transform: translateY(-10px);
		box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
	}

	.news-image {
		height: 200px;
		overflow: hidden;
	}

	.news-image img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: var(--transition);
	}

	.news-card:hover .news-image img {
		transform: scale(1.05);
	}

	.news-content {
		padding: 20px;
	}

	.news-date {
		color: var(--gray);
		font-size: 14px;
		margin-bottom: 10px;
		display: block;
	}

	.news-title {
		font-size: 18px;
		margin-bottom: 10px;
		color: var(--dark);
		text-decoration: none;
		transition: var(--transition);
	}

	.news-title:hover {
		color: var(--primary);
	}

	.news-excerpt {
		color: var(--gray);
		font-size: 14px;
	}

	/* 页脚样式 */
	footer {
		background-color: #1a1f2e;
		color: #a0a8b7;
		padding: 60px 0 0;
	}

	.footer-content {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		gap: 40px;
		margin-bottom: 40px;
	}

	.footer-column h3 {
		color: white;
		font-size: 20px;
		margin-bottom: 20px;
		position: relative;
		padding-bottom: 10px;
	}

	.footer-column h3:after {
		content: '';
		position: absolute;
		width: 40px;
		height: 3px;
		background-color: var(--secondary);
		bottom: 0;
		left: 0;
	}

	.footer-links {
		list-style: none;
	}

	.footer-links li {
		margin-bottom: 10px;
	}

	.footer-links a {
		color: #a0a8b7;
		text-decoration: none;
		transition: var(--transition);
	}

	.footer-links a:hover {
		color: white;
		padding-left: 5px;
	}

	.contact-info {
		list-style: none;
	}

	.contact-info li {
		margin-bottom: 15px;
		display: flex;
		align-items: flex-start;
	}

	.contact-info i {
		margin-right: 10px;
		color: var(--secondary);
		margin-top: 5px;
	}

	.social-links {
		display: flex;
		gap: 15px;
		margin-top: 20px;
	}

	.social-links a {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		background-color: #2a3142;
		border-radius: 50%;
		color: #a0a8b7;
		text-decoration: none;
		transition: var(--transition);
	}

	.social-links a:hover {
		background-color: var(--primary);
		color: white;
	}

	.footer-bottom {
		background-color: #151822;
		padding: 20px 0;
		text-align: center;
		border-top: 1px solid #2a3142;
	}

	.footer-bottom p {
		margin-bottom: 5px;
		font-size: 14px;
	}

	.footer-bottom a {
		color: #a0a8b7;
		transition: var(--transition);
	}

	.footer-bottom a:hover {
		color: white;
	}

	/* 响应式设计 */
	@media (max-width: 991px) {
		.about-content {
			flex-direction: column;
		}

		.hero h1 {
			font-size: 36px;
		}

		.hero p {
			font-size: 18px;
		}
	}

	@media (max-width: 768px) {
		.nav-links {
			display: none;
			position: absolute;
			top: 70px;
			left: 0;
			width: 100%;
			background-color: white;
			flex-direction: column;
			padding: 20px;
			box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
		}

		.nav-links.active {
			display: flex;
		}

		.nav-links li {
			margin: 10px 0;
		}

		.mobile-menu {
			display: block;
		}

		.hero {
			padding: 150px 0 80px;
		}

		.section {
			padding: 80px 0;
		}

		.btn-outline {
			margin-left: 0;
			margin-top: 15px;
			display: block;
		}
	}
</style>